enum STATUS {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export default STATUS;
